var React = require('react');

function SearchInline (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"d":"M495.04,404.48L410.56,320c15.36-30.72,25.6-66.56,25.6-102.4C436.16,97.28,338.88,0,218.56,0S0.96,97.28,0.96,217.6\r\n\t\t\ts97.28,217.6,217.6,217.6c35.84,0,71.68-10.24,102.4-25.6l84.48,84.48c25.6,25.6,64,25.6,89.6,0\r\n\t\t\tC518.08,468.48,518.08,430.08,495.04,404.48z M218.56,384c-92.16,0-166.4-74.24-166.4-166.4S126.4,51.2,218.56,51.2\r\n\t\t\ts166.4,74.24,166.4,166.4S310.72,384,218.56,384z"}))));
}

SearchInline.defaultProps = {"viewBox":"0 0 513.28 513.28","height":"48.004"};

module.exports = SearchInline;

SearchInline.default = SearchInline;
